var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
import { breakpoints, theme } from '@shapeable/theme';
import { useEntity } from '../hooks/use-entity';
import { ExplorerNavigation, ExplorerNavigationDefaultProps } from './explorer-navigation';
var cls = classNames('explorer-header');
export var ExplorerAsideHeaderDefaultProps = {
  navigationProps: ExplorerNavigationDefaultProps
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    padding: 0 ", " ", " ", ";\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n    overflow: visible;\n    align-self: stretch;\n  "], ["\n    display: flex;\n    padding: 0 ", " ", " ", ";\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n    overflow: visible;\n    align-self: stretch;\n  "])), theme.UNIT(4), theme.UNIT(5), theme.UNIT(4))
});
var NavigationStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var NameStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Navigation: styled(ExplorerNavigation)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), NavigationStyles)
};
export var ExplorerAsideHeader = function (props) {
  var className = props.className,
    children = props.children,
    navigationProps = props.navigationProps;
  var entity = useEntity(props.entity);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Navigation, __assign({
    entity: entity
  }, navigationProps)), children);
};
ExplorerAsideHeader.defaultProps = ExplorerAsideHeaderDefaultProps;
ExplorerAsideHeader.cls = cls;
// BACK COMPAT
export var EntityGridDetailsAsideHeader = ExplorerAsideHeader;
export var EntityGridDetailsAsideHeaderDefaultProps = ExplorerAsideHeaderDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;